import React, {useEffect, useState} from "react";
import {withTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import swal from "sweetalert";
import AddButton from "../../components/AddButton";
import Pagination from "../../components/Pagination";
import Select from "../../components/Select";
import {createUnits, deleteUnits} from "../../services/unitService";
import EditButton from "../../components/EditButton";
import DeleteButton from "../../components/DeleteButton";
import Loading from "../../components/loading";
import SearchInput from "../../components/search/SearchInput";
import {Context} from "../../context/SearchContext";
import {useContext} from "react";
import {toast} from "react-toastify";
import TempDataTable from "../../components/TemDataTable";

const headerTable = [{
    name: "id", sort: false
}, {
    name: "name", sort: true
}, {
    name: "short_name", sort: true
}, <span className="sr-only">Edit</span>,];

const bodyTable = ["id", "name", "shortName", "actions"];

const Units = ({t}) => {

    const {token} = useSelector((state) => state.user);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [itemOffset, setItemOffset] = useState(0);
    const [data, setData] = useState({
        data: [], recordsTotal: 0, pageCount: 1,
    });
    const [forcePage, setForcePage] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDir, setSortDir] = useState("DESC");
    const [clear, setClear] = useState(false);
    const navigate = useNavigate();
    const ctx = useContext(Context);
    const oldSelectedId = localStorage.getItem("selectedId") ? parseInt(localStorage.getItem("selectedId")) : null
    const [selectedId, setSelectedId] = useState(oldSelectedId);

    const handlePageClick = (event) => {
        setForcePage(event.selected);
        const newOffset = (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
        setItemOffset(newOffset);
    };

    const onDeleteItem = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`), text: t(`action.delete_item.text`), icon: "warning", buttons: {
                cancel: true, confirm: true,
            },
        });
        if (responseReceived) {
            setIsLoading(true);
            const response = await deleteUnits(`${process.env.REACT_APP_HOST_BASE_URL}/v1/unit/${id}`, token);
            if (response.success) {
                setIsLoading(false);
                fetchData();
                toast.success(t('action.delete_success'), {
                    position: "bottom-right", autoClose: 3000, closeOnClick: true, className: "add-success"
                });
            } else {
                setIsLoading(false);
                if (response.status === 420) {
                    toast.warn(response.body.error, {
                        position: "bottom-right",
                        autoClose: 10000,
                        closeOnClick: true,
                        className: "product-background",
                        pauseOnHover: true,
                    });
                } else {
                    navigate("/error", {
                        state: {
                            status: response.status, message: response.body ? response.body.error : "Error",
                        },
                    });
                }
            }
        } else {
            return;
        }
    };
    const fetchData = async () => {
        const response = await createUnits(`${process.env.REACT_APP_HOST_BASE_URL}/v1/unit/table`, token, {
            draw: 1,
            start: itemOffset,
            length: itemsPerPage,
            recordsTotal: 0,
            columns: [],
            order: [{column: sortColumn, dir: sortDir}],
            search: {value: ctx.state, regex: true},
            filter: {},
        });
        if (response.success) {
            setIsLoading(false);
            setClear(false);
            let reviewData = response.data.data.map((item, index) => {
                return {
                    id: index + 1, name: item.name, shortName: item.shortName, actions: (<>
                        <EditButton onclick={() => navigate(`/units/update/${item.id}`)}/>
                        <DeleteButton onclick={() => onDeleteItem(item.id)}/>
                    </>),
                };
            });

            setData({
                data: reviewData,
                recordsTotal: response.data.recordsFiltered,
                pageCount: Math.ceil(response.data.recordsFiltered / parseInt(itemsPerPage)),
            });
        } else {
            setIsLoading(false);
            navigate("/error", {
                state: {
                    status: response.status, message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (clear) {
            fetchData();
        }
    }, [clear]);

    useEffect(() => {
        fetchData();
    }, [itemOffset, itemsPerPage, ctx.state]);

    const sortFunction = (value) => {
        setSortColumn(value.field ? value.field : "id");
        setSortDir(value.sort === true ? 'ASC' : 'DESC');
        setClear(true);
    }

    return (<>
        {isLoading && <Loading/>}
        <div className="px-4 py-4 sm:px-6 lg:px-8">
            <div className="mb-2 sm:flex sm:items-center">
                <div className="sm:flex-auto">
                    <h1 className="text-xl font-semibold text-gray-900">
                        {t(`units`)}
                    </h1>
                </div>
                <AddButton title={t(`add_unit`)} url={"add"}/>
            </div>

            <div>
                <div className="flex justify-between items-center">
                    <Select
                        setItemsPerPage={setItemsPerPage}
                        itemsPerPage={itemsPerPage}
                    />
                    <SearchInput/>
                </div>
                <TempDataTable
                    data={data.data}
                    headerTable={headerTable}
                    bodyContent={bodyTable}
                    sortFunction={sortFunction}
                    selectedRowId={selectedId}
                    rowHandler={(id) => {
                        setSelectedId(id);
                    }}
                />
                <Pagination
                    handlePageClick={handlePageClick}
                    pageCount={data.pageCount}
                    forcePage={forcePage}
                />
            </div>
        </div>
    </>);
};

export default withTranslation()(Units);
